import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=900f0a42&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"
import style0 from "./commentList.vue?vue&type=style&index=0&id=900f0a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900f0a42",
  null
  
)

export default component.exports